import { Card, CardContent, Grid } from '@mui/material';
import Breadcrumb from 'components/ui/Breadcrumb';
import { useEffect, useState } from 'react';
import PollQuestionForm from '../components/poll-questions/PollQuestionForm';
import QuestionsForm from '../components/questions/QuestionsForm';
import { getUserPollQuestions, getUserQuestions, saveUserAnswers, saveUserPollQuestionsAnswers } from '../services/user';
import { pickProperties } from '../utils';

function PollQuestionsPage(props) {
    const [userQuestionsLoading, setUserQuestionsLoading] = useState(true);

    const [questionsFormInitialValues, setQuestionsFormInitialValues] = useState();

    useEffect(() => {
        async function fetchUserQuestions() {
            setUserQuestionsLoading(true);
            const result = await getUserPollQuestions();
            if (result.error === false) {
                const formData = {};
                const answersMap = {};
                result.answers.forEach((answer) => {
                    answersMap[answer.questionId] = {
                        answerText: answer?.answerText ?? '',
                        answerId: answer?.answerId ?? null,
                        studentId: answer?.studentId ?? null
                    };
                });
                formData.questions = result.questions.map((question) => ({
                    ...question,
                    questionId: question._id,
                    answerText: answersMap?.[question._id]?.answerText ?? '',
                    // new (there is no need for the condition as we get answer always in answerId only)
                    answerId: answersMap?.[question._id]?.answerId ?? null
                    // old
                    // answerId:
                    //     question.optionType === 'STUDENT'
                    //         ? answersMap?.[question._id]?.studentId ?? null
                    //         : answersMap?.[question._id]?.answerId ?? null
                }));
                formData.students = result.students;
                setQuestionsFormInitialValues(formData);
            }
            setUserQuestionsLoading(false);
        }
        fetchUserQuestions();
    }, []);

    const handleQuestionsFormSubmit = async (values) => {
        const questions = values.questions.map((question) => {
            const formattedObj = pickProperties(question, ['questionId', 'answerId']);
            if (formattedObj?.answerId && formattedObj?.answerId?._id) {
                formattedObj.answerId = formattedObj.answerId._id;
            }
            return formattedObj;
        });

        const result = await saveUserPollQuestionsAnswers(questions);
    };

    return (
        <>
            <Breadcrumb title="Poll Questions" />
            <Grid container justifyContent="center">
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Grid container>
                                <Grid item xs={12}>
                                    {userQuestionsLoading ? (
                                        <div>Loading...</div>
                                    ) : (
                                        <PollQuestionForm
                                            initialValues={questionsFormInitialValues}
                                            handleSubmit={handleQuestionsFormSubmit}
                                            enableReinitialize={false}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}

export default PollQuestionsPage;
